import * as unLogin from "./unLogin"; // 用户注册与登录,
import * as role from "./role"; // 权限管理,
import * as user from "./user"; // 用户信息,
import * as course from "./course"; // 课程,
import * as Class from "./class"; // 教室管理,
import * as student from "./student"; // 学生管理,
import * as teacher from "./teacher"; // 老师,
import * as lessonPlan from "./lessonPlan"; // 课程计划
import * as worker from "./worker"; // 员工
import * as qiniu from "./qiniu"; // 七牛云,
import * as timetable from "./timetable"; // 七牛云,
import * as org from "./org"; // 七牛云,
import * as project from "./project";
import axios from "axios"; // 作品,

export default {
  ...unLogin,
  ...timetable,
  ...role,
  ...user,
  ...course,
  ...qiniu,
  ...Class,
  ...student,
  ...teacher,
  ...lessonPlan,
  ...worker,
  ...org,
  ...project
};

export function upload(data) {
  return axios.post(process.env.VUE_APP_QINIU_UPLOAD_URL, data, {
    timeout: 31536000000
  })
}